// import { useEffect, useState } from "react";
// import {
//   ContentSection,
//   SpreadsheetSection,
//   WelcomeSection,
// } from "../components/layout/LandingPage";
// import { listRecentPosts } from "../api";

// export const LandingPage = () => {
//   const [recentPosts, setRecentPosts] = useState([]);

//   const currentTimestamp = Math.floor(Date.now() / 1000);

//   useEffect(() => {
//     const fetchPosts = async () => {
//       try {
//         // get articles data
//         const result = await listRecentPosts();
//         const publishPosts = result?.data.filter(post => post.publish_date <= currentTimestamp);
//         setRecentPosts(publishPosts);
//       } catch (error) {
//         console.error("Error fetching posts:", error);
//       }
//     };
//     fetchPosts();
//     // console.log(recentPosts);
//   }, []);

//   return (
//     <div className="bg-beige-prim pt-5 md:pt-10">
//       <WelcomeSection />
//       <div className="bg-beige-sec">
//         <ContentSection recentPosts={recentPosts} />
//       </div>
//       <SpreadsheetSection />
//     </div>
//   );
// };

import { useEffect, useState } from "react";
import {
  ContentSection,
  SpreadsheetSection,
  WelcomeSection,
} from "../components/layout/LandingPage";
import { listRecentPosts } from "../api";
import {SubscribeSuccessPopup} from "../components/UI/SubscribeSuccessPopup";

export const LandingPage = () => {
  const [recentPosts, setRecentPosts] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const currentTimestamp = Math.floor(Date.now() / 1000);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const result = await listRecentPosts();
        const publishPosts = result?.data.filter(
          (post) => post.publish_date <= currentTimestamp,
        );
        setRecentPosts(publishPosts);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPosts();
  }, []);

  const handleLandingSubscribe = () => {
    setShowPopup(true);
  };

  return (
    <div className="bg-beige-prim pt-5 md:pt-10">
      <WelcomeSection onSubscribeSuccess={handleLandingSubscribe} />

      {showPopup && (
        <SubscribeSuccessPopup onClose={() => setShowPopup(false)} />
      )}

      <div className="bg-beige-sec">
        <ContentSection recentPosts={recentPosts} />
      </div>

      <SpreadsheetSection />
    </div>
  );
};
